var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_1658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.88184 0 0 7.88184 0 17.5C0 27.1182 7.88184 35 17.5 35C27.1182 35 35 27.1182 35 17.5C35 7.88184 27.1182 0 17.5 0Z",
    fill: "#003032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1024 13.8906L17.4999 23.5293L15.3876 25.457L7.71765 17.7871L10.6093 14.8954L15.5108 19.7969L17.4999 17.9922L25.3545 10.8555L28.1024 13.8906Z",
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_1658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.b40405a65714fef2d571c005e6a36d65.svg";
export { ForwardRef as ReactComponent };